import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_left",
  "use": "icon-i_left-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_left\"><title>icon_画板</title><path d=\"M20.6,25.72a1,1,0,0,1-.74-.33L12.67,17.8a1.17,1.17,0,0,1,0-1.58l7.19-7.6a1,1,0,0,1,1.49,0,1.17,1.17,0,0,1,0,1.58L14.9,17l6.45,6.81a1.16,1.16,0,0,1,0,1.57A1,1,0,0,1,20.6,25.72Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol